module.exports = __webpack_public_path__ + "img/default_avatar.740f652f.png";